import React from 'react'
import OppBriefSection from "./OppBriefSection";
import { List } from "antd";

export default class OppBriefTimingSection extends OppBriefSection {

    static sectionTitle = 'Project Timing';

    static TranslationKey = 'start_project.contract_schedule';

    static CompletedField = 'accepted_schedule_at';

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
        };
    }


    render() {
        let { opportunity } = this.props;
        let { project_position, project } = opportunity;

        let start = opportunity.confirmed_started_at || project_position.started_at;
        let end = opportunity.confirmed_ended_at || project_position.ended_at;

        // if it's 0 average hours and cost based retainer, show "Not specified (retainer)", otherwise show the hours
        const avgHoursPerPeriod = (!opportunity.confirmed_avg_hours_per_period && !project_position.avg_hours_per_period) && project_position.isFixedRetainerCostPerPeriodBased() ? 'Not specified (retainer)' : `${opportunity.confirmed_avg_hours_per_period || project_position.avg_hours_per_period} hrs`;

        return (
            <div className="project-brief-section">
                <div className="deliverable-category-container role-skill-overview mt-5 flex flex-col">

                    <div className="deliverable-panel mt-3">

                        <div className="flex deliverable-details-panel">
                            <div className="deliverable-section">
                                <p className={`deliverable-section-title ${opportunity.hasUnseenUpdateToProjectPositionStartedAt() ? 'opp-unseen-update' : ''}`}>
                                    Start Date
                                </p>
                                <p className="deliverable-section-description">
                                    {TB.moment(start)?.format('ll')}
                                </p>
                            </div>
                            <div className="deliverable-section">
                                <p className={`deliverable-section-title ${opportunity.hasUnseenUpdateToProjectPositionEndedAt() ? 'opp-unseen-update' : ''}`}>
                                    End Date
                                </p>
                                <p className="deliverable-section-description">
                                    {TB.moment(end)?.format('ll')}
                                </p>
                            </div>

                            <div className="deliverable-section" />

                            {/* {opportunity.isFixedFee() ? (
                                <div className="deliverable-section">
                                    <p className={`deliverable-section-title `}>
                                        Estimated # of Hours
                                    </p>
                                    <p className="deliverable-section-description">
                                        {project_position.total_hours} hours
                                    </p>
                                </div>
                            ) : (
                                <div className="deliverable-section" />
                            )} */}
                        </div>
                    </div>
                    {!opportunity.isFixedFee() && (

                        <div className="deliverable-panel">

                            <div className="flex deliverable-details-panel">
                                <div className="deliverable-section">
                                    <p className={`deliverable-section-title ${opportunity.hasUnseenUpdateToProjectPositionStartedAt() || opportunity.hasUnseenUpdateToProjectPositionEndedAt() ? 'opp-unseen-update' : ''}`}>
                                        Estimated Timeline
                                    </p>
                                    <p className="deliverable-section-description">
                                        {/* {project_position.total_weeks} Weeks */}
                                        {project_position.isFixedRetainer() ? (
                                            <>
                                                {project_position.actual_total_periods} {project_position.payout_frequency === 'monthly' ? 'Months' : 'Weeks'}
                                            </>
                                        ) : (
                                            <>
                                                {project_position.total_weeks} Weeks
                                            </>
                                        )}
                                    </p>
                                </div>
                                <div className="deliverable-section">
                                    <p className={`deliverable-section-title ${opportunity.hasUnseenUpdateToProjectPositionAvgHoursPerWeek() ? 'opp-unseen-update' : ''}`}>
                                        Average Hours Per {project_position.payout_frequency === 'monthly' ? 'Month' : 'Week'}
                                    </p>
                                    <p className="deliverable-section-description">
                                        {/* {opportunity.confirmed_avg_hours_per_period || project_position.avg_hours_per_period} hrs */}
                                        {avgHoursPerPeriod}
                                    </p>
                                </div>
                                <div className="deliverable-section">
                                    <p className={`deliverable-section-title ${opportunity.hasUnseenUpdateToProjectPositionOnsiteRequirements() ? 'opp-unseen-update' : ''}`}>
                                        Required On-Site

                                    </p>
                                    <p className="deliverable-section-description">
                                        {project_position.requiredOnSiteDetails()}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                    {opportunity.isFixedFee() && project_position?.deliverables?.length > 0 && (
                        <div>
                            <div className="flex flex-col items-stretch mt-1.5 gap-2">
                                <p className="text-sm text-wripplePrimaryDarkNavy font-semibold">
                                    Requested Deliverables:
                                </p>
                                <List
                                    size="large"
                                    dataSource={project_position.deliverables}
                                    renderItem={(deliverable) => (
                                        <List.Item className="flex-col">
                                            <div key={deliverable.id} className="flex flex-col gap-1.5 self-stretch items-stretch">
                                                <p className="text-base">
                                                    <span className="font-medium text-primary">
                                                        {deliverable.name}
                                                    </span>
                                                </p>
                                                <p className="text-xs mb-3.5">
                                                    {deliverable.description || <i>No Description Provider</i>}
                                                </p>
                                                <div className="flex flex-row flex-wrap items-center justify-start">
                                                    {project_position?.fixedFeePricingStrategyIsFullBreakdown() && (
                                                        <p className="text-xs min-w-[220px] max-w-[2200px]">
                                                            <span className="font-medium">Estimated # of hours:</span>
                                                            &nbsp;
                                                            {deliverable.total_hours}
                                                        </p>
                                                    )}

                                                    <p className="text-xs min-w-[220px] max-w-[2200px]">
                                                        <span className="font-medium">Target Delivery Date:</span>
                                                        &nbsp;
                                                        {deliverable.target_delivery_at ? TB.moment(deliverable.target_delivery_at)
                                                            .format('ll') : (
                                                            <i>N/A</i>
                                                        )}
                                                    </p>

                                                </div>
                                            </div>
                                        </List.Item>
                                    )} />

                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

}


const styles = {
    stepContainer: {
        backgroundColor: 'white',
    },
    substepTitle: {
        textAlign: 'center',
        color: '#90A0B7',
        fontSize: 14,
        marginBottom: 25,
    },
};